import {doc, getDoc} from 'firebase/firestore';
import {db} from '../../../shared/services/firebase';
import {fail, logError, ok, toConfigError} from './apiHelpers';

/**
 * Read edge-level feature flags (e.g. sgrcontainer).
 */
export const getEdgeFlags = async (edgeId) => {
  try {
    const snap = await getDoc(doc(db, 'edges', edgeId));
    if (!snap.exists()) return ok({});
    const {sgrcontainer} = snap.data();
    return ok({sgrcontainer: sgrcontainer ?? false});
  } catch (error) {
    const errorInfo = toConfigError(error, 'CONFIG_LOAD_FAILED');
    logError('getEdgeFlags', errorInfo);
    return fail(errorInfo);
  }
};

